import { Fragment } from "react";

import LegalPageContent from "../common/LegalPageContent";

const PrivacyModal = () => {
  return (
    <Fragment>
      <LegalPageContent slug="privacy-policy" />
    </Fragment>
  );
};

export default PrivacyModal;
